import DecisionTreeVS2Builder from "./DecisionTreeVS2/builder";

// Template registry for dynamic template loading
const TEMPLATE_REGISTRY = {
  "Decision Tree-VS 2": DecisionTreeVS2Builder,
};

const DEFAULT_TEMPLATE = "Decision Tree-VS 2";

export const getTemplateBuilder = (configuration) => {
  const templateName =
    configuration?.settings?.find((setting) => setting.settingId === 93 && setting.isEnabled)?.value ||
    DEFAULT_TEMPLATE;
  return TEMPLATE_REGISTRY[templateName];
};

export default TEMPLATE_REGISTRY;
